import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { Select, IProps as SelectProps } from 'components/atoms/Select/Select.components';
import { useGetPicklistQuery } from 'services/sap';
import { formatCountrySelect, getAvailableItems } from 'utils/helpers';
import { catalogoPersonal, catalogoLenguage } from 'utils/helpers/dictionaries';

interface CitySelectProps extends Omit<SelectProps, 'options'> {
  department: string;
  onExternalCodeChange?: (externalCode: string) => void;
  name?: string;
  catalogName?: string;
  father?: string;
  defaultValue?: string;
}

export default function CitySelect({
  department,
  onExternalCodeChange,
  name = '',
  defaultValue = '',
  catalogName = catalogoPersonal.MUNICIPALITY_COL,
  father = catalogoPersonal.MUNICIPALITY_COL,
  ...rest
}: Readonly<CitySelectProps>) {
  const { refetch, data, isLoading, isError } = useGetPicklistQuery<{
    data: { externalCode: string; label_es_ES: string }[];
    isLoading: boolean;
    isError: boolean;
  }>({
    catalogName,
    languages: catalogoLenguage.ESyUSyISOyId,
    father,
  });

  const [initialLoading, setInitialLoading] = useState(false);

  const options = formatCountrySelect({ initialList: data ?? [], isStateOrCity: true });

  useEffect(() => {
    if (catalogName && father) refetch();
  }, [catalogName, father]);

  useEffect(() => {
    if (!data || isLoading || !defaultValue || initialLoading) {
      return;
    }
    const city = data?.find((c) => c.label_es_ES === defaultValue);

    if (!city) {
      return;
    }

    if (onExternalCodeChange) {
      onExternalCodeChange(city?.externalCode ?? '');
    }
    rest.handleChange(defaultValue ?? '');

    setInitialLoading(true);
  }, [isLoading, data]);

  return (
    <Select
      options={options}
      {...rest}
      disabled={rest.disabled || isError}
      handleChange={(value) => {
        let city;
        if (value) {
          city = data?.find((c) => c.label_es_ES === value);
        }
        if (onExternalCodeChange) {
          onExternalCodeChange(city?.externalCode ?? '');
        }
        rest.handleChange(value ?? '');
      }}
    />
  );
}
